export function open(url: string, target?: string) {
  window.open(url, target)
}
